import React from "react"

export const LuiBanner: React.FC<{ level: "success" | "info" | "warning" | "error" }> = (props) => {
  let materialIcon = getMaterialIconForLevel(props.level)

  return (
    <div className="lui-msg-banner-container">
      <div className={`lui-msg-${props.level} lui-msg-dynamic-banner`}>
        <i className="lui-msg-status-icon material-icons-round">{materialIcon}</i>
        <div>
          <span className="lui-icon" />
          {props.children}
        </div>
      </div>
    </div>
  )
}

export function getMaterialIconForLevel(level: "success" | "info" | "warning" | "error") {
  switch (level) {
    case "success":
      return "check_circle"
    case "info":
      return "info"
    case "warning":
      return "warning"
    case "error":
      return "error"
  }
}
